// Add your custom JS here.
( function( $ ) {

    // Fade in effects
    AOS.init();
    
    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300
    });

    // Swiper example
    // var swiper = new Swiper(".carouselname-swiper", {
    //     slidesPerView: "auto",
    //     center: true,
    //     loop: false,
    //     pagination: {
    //         el: ".carouselname-pagination",
    //         clickable: true,
    //         renderBullet: function (index, className) {
    //             return '<span class="' + className + '"></span>';
    //         },
    //     },
    //     navigation: {
    //         nextEl: ".carouselname-next",
    //         prevEl: ".carouselname-prev",
    //     },
    //     breakpoints: {
    //         768: {
    //           spaceBetween: 500,
    //         },
    //         1024: {
    //           spaceBetween: 500,
    //         },
    //       },
    // });

} )( jQuery );